import React, { useState } from 'react'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import { StepCarouselWrapper } from '../style'

interface Step {
  title: string
  description: React.ReactNode
}

const steps: Step[] = [
  {
    title: 'Passo 1',
    description: (
      <>
        <strong>Baixe o aplicativo FGTS</strong>
        <br />
        <ol>
          <li>Acesse a loja de aplicativos do seu celular</li>
          <li>Instale o app FGTS, da Caixa Econômica Federal</li>
        </ol>
      </>
    )
  },
  {
    title: 'Passo 2',
    description: (
      <>
        <strong>Ative o Saque-Aniversário</strong>
        <br />
        <ol>
          <li>Abra o app FGTS</li>
          <li>Vá em “Sistemática de Saque do seu FGTS”</li>
          <li>Leia os termos e condições</li>
          <li>Toque em “Optar pelo Saque-Aniversário”</li>
        </ol>
      </>
    )
  },
  {
    title: 'Passo 3',
    description: (
      <>
        <strong>Acesse o menu “Mais”</strong>
        <br />
        <ol>
          <li>Toque em “Mais”, na barra inferior do aplicativo</li>
        </ol>
      </>
    )
  },
  {
    title: 'Passo 4',
    description: (
      <>
        <strong>Autorize a consulta do seu saldo</strong>
        <br />
        <ol>
          <li>
            No menu “Mais”, escolha “Autorização de consulta às informações do
            FGTS”
          </li>
        </ol>
      </>
    )
  },
  {
    title: 'Passo 5',
    description: (
      <>
        <strong>Selecione a opção “Empréstimo Saque-Aniversário”</strong>
        <br />
        <ol>
          <li>
            Na tela de autorização, escolha “Empréstimo Saque-Aniversário”
          </li>
        </ol>
      </>
    )
  },
  {
    title: 'Passo 6',
    description: (
      <>
        <strong>Adicione a instituição financeira</strong>
        <br />
        <ol>
          <li>Toque em “Adicionar instituição +”</li>
          <li>Digite Banco BMG no campo de busca</li>
          <li>Selecione o Banco BMG e toque em Continuar</li>
        </ol>
      </>
    )
  },
  {
    title: 'Passo 7',
    description: (
      <>
        <strong>Confirme a autorização</strong>
        <br />
        <ol>
          <li>Finalize tocando em “Sim” para confirmar a autorização</li>
        </ol>
      </>
    )
  },
  {
    title: 'Passo 8',
    description: (
      <>
        <strong>Volte aqui e antecipe seu FGTS</strong>
        <br />
        <ol>
          <li>Depois de concluir o processo no app FGTS</li>
          <li>Clique em “Antecipar meu FGTS” e siga as instruções</li>
        </ol>
      </>
    )
  }
]

const StepCarousel: React.FC = () => {
  const [index, setIndex] = useState(0)

  const next = () => setIndex((prev) => Math.min(prev + 1, steps.length - 1))
  const prev = () => setIndex((prev) => Math.max(prev - 1, 0))

  return (
    <StepCarouselWrapper className="text-start p-4">
      <div className="custom-badge">{steps[index].title}</div>

      <div className="mb-3">{steps[index].description}</div>

      <div className="d-flex gap-3 mt-4">
        <button
          onClick={prev}
          disabled={index === 0}
          className="btn btn-outline-dark d-flex align-items-center justify-content-center rounded-circle"
          style={{ width: '48px', height: '48px' }}
        >
          <FaArrowLeft />
        </button>
        <button
          onClick={next}
          disabled={index === steps.length - 1}
          className="btn btn-outline-dark d-flex align-items-center justify-content-center rounded-circle"
          style={{ width: '48px', height: '48px' }}
        >
          <FaArrowRight />
        </button>
      </div>
    </StepCarouselWrapper>
  )
}

export default StepCarousel
